import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { xeroQueryKeys } from "./xeroQueryKeys";

export const useQueryXeroGetAccountMapping = ({ api }: { api: ApiType }) =>
  useQuery({
    queryKey: xeroQueryKeys.getAccountMapping(),
    queryFn: async () => (await api.xeroApi.getAccountMapping()).data,
  });
